import api from '../index';

const baseUrl = '/invoice';

export const createInvoiceApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/create-invoice-pdf/${roId}`,
  });
};

export const getInvoiceApi = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-invoice-by-id/${id}`,
  });
};

export const getInvoicesApi = (query = false) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-invoice-list?unpaid=${query}`,
  });
};

export const getINvoiceTemplates = () => {
  return api({
    method: 'get',
    url: 'invoice-template/get-invoice-templates',
  });
};
export const saveInvoiceTemplate = (data) => {
  return api({
    method: 'post',
    url: 'invoice-template/save-invoice-templates',
    data: data,
  });
};
export const updateInvoiceTemplate = (data) => {
  return api({
    method: 'put',
    url: 'invoice-template/update-invoice-templates',
    data,
  });
};

export const addNotesAfterPayment = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/add-notes-after-payment`,
    data,
  });
};

export const updateFeeData = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-fees-data`,
    data,
  });
};
